/**
 * @param {string} text
 * @param {[{event: string, callback: function}]|function} callbacks
 * @param {string|string[]} cssClass
 * @param aria
 * @param {Document} documentRoot
 * @param {AddEventListenerOptions} listenerOptions
 * @return {HTMLButtonElement}
 */
export function createButton(
  text,
  callbacks,
  cssClass = null,
  aria,
  documentRoot = document,
  listenerOptions,
) {
  const button = documentRoot.createElement("button");
  const content = documentRoot.createElement("span");

  button.type = "button";
  content.classList.add("rhea-button__text");
  content.textContent = text ?? "";
  button.append(content);

  if (aria) {
    for (let key in aria) {
      if (aria[key] !== undefined && aria[key] !== null) {
        button.setAttribute(`aria-${key}`, aria[key]);
      }
    }
  }

  if (typeof callbacks === "function") {
    button.addEventListener("click", callbacks, listenerOptions);
  } else {
    callbacks.forEach(({ event, callback }) => {
      button.addEventListener(event, callback, listenerOptions);
    });
  }
  button.classList.add("rhea-button");
  if (cssClass) {
    if (Array.isArray(cssClass)) button.classList.add(...cssClass);
    else button.classList.add(cssClass);
  }
  button.title = text ?? "";
  return button;
}

/**
 *
 * @param {{path: string, name: string}}download
 */
export function startDownload(download, documentRoot = document) {
  const link = documentRoot.createElement("a");

  link.href = download.path;
  link.download = download.name;
  documentRoot.body.append(link);
  link.click();
  link.remove();
}
